<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="requestrrd">
              <i class="fa fa-file"></i>Request RRD
            </b-dropdown-item>
            <b-dropdown-item @click="approvalConfirm" :disabled="!model.requestkey">
              <i class="fa fa-send"></i>Send Appoval Request
            </b-dropdown-item>
          </b-dropdown>
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.agreement"
                  placeholder="No Agreement"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 100px">No. Kontrak</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.nomor"
              placeholder="No Kontrak"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="refresh()"
                class="ml-3"
              >
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          @row-clicked="rowClicked"
          show-empty
        >
          <template v-slot:thead-top="data">
            <b-tr>
              <b-th variant="primary" colspan="13" class="text-center">MEMO PENGAMBILAN JAMINAN</b-th>
              <b-th variant="dark" colspan="4" class="text-center">REQUEST APPROVAL</b-th>
            </b-tr>
          </template>
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
          <template
          v-slot:cell(submitdate)="data"
        >{{ data.item.submitdate | moment("DD MMM YYYY") }}</template>
         <template
          v-slot:cell(duedate_memo)="data"
        >{{ data.item.duedate_memo | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(tgl_kontrak)="data"
        >{{ data.item.tgl_kontrak | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(settlementdate)="data"
        >{{ data.item.settlementdate | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(tglpelunasan)="data"
        >{{ data.item.tglmulaipelunasan | moment("DD MMM YYYY") }} - {{ data.item.tglpelunasan | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(requestdate)="data"
        >{{ data.item.requestdate | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(jaminanamt)="data">{{ data.item.jaminanamt | numFormat('0,0.00') }}</template>
        <template v-slot:cell(paymentamt)="data">{{ data.item.paymentamt | numFormat('0,0.00') }}</template>
        <template v-slot:cell(akumpaidamt)="data">{{ data.item.akumpaidamt | numFormat('0,0.00') }}</template>        
        <template v-slot:cell(diskon_amount)="data">{{ data.item.diskon_amount | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlmustpay)="data">{{ data.item.ttlmustpay | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlpayment_diskon)="data">{{ data.item.ttlpayment_diskon | numFormat('0,0.00') }}</template>
        <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">{{ data.item.CONTRACT_PREPAID_AMT | numFormat('0,0.00') }}</template>
        <template v-slot:cell(prepaid)="data">{{ data.item.prepaid | numFormat('0,0.00') }}</template>
        <template v-slot:cell(net_ttlangsuran)="data">{{ data.item.net_ttlangsuran | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlpayment)="data">{{ data.item.ttlpayment | numFormat('0,0.00') }}</template>
        <template v-slot:cell(OS_pokok_due)="data">{{ data.item.OS_pokok_due | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlprincipalcurrent)="data">{{ data.item.ttlprincipalcurrent | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlosprincipal_untilmaturity)="data">{{ data.item.ttlosprincipal_untilmaturity | numFormat('0,0.00') }}</template>
        
        <template v-slot:cell(wo_status)="data">{{ data.item.wo_status==1?'WO':'Normal'}}</template>
        <template v-slot:cell(status_memo)="data">
          <span v-if="(data.item.status_memo_rrd == 'Approved' || data.item.status_memo == 'Rejected' || data.item.status_memo == 'Send Approval')" @click="approvalInfoConfirm" :class="data.item.status_memo=='Approved'?'alert-success navbar-link p-1':data.item.status_memo=='Send Approval'?'alert-info navbar-link p-1':'alert-danger navbar-link p-1'" style="cursor: pointer;">
            <span>{{data.item.status_memo}}</span>
          </span>
          <span v-else>
            <span>{{data.item.status_memo}}</span>
          </span>
        </template>
        <template v-slot:cell(paid_date)="data">
          <span v-if="(data.item.status_memo == 'Approved' || data.item.status_memo == 'Rejected')">
            <span> - </span>
          </span>
          <span v-else>
            <span v-if="data.item.ispaid==1">{{data.item.paid_date | moment('DD MMM YYYY')}}</span>
          </span>
        </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Request Form RRD" size="lg" :centered="true" hide-footer>

          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Aggrement</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_agreement"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Kontrak</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_kontrak"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Debitur Name</label></b-input-group-prepend>
                      <b-form-input v-model="model.CustName"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Debitur No. (CIF)</label></b-input-group-prepend>
                      <b-form-input v-model="model.CustCode"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row > 
          <hr />
          <b-row>
              <b-col md="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestdate" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">    
                  <b-input-group>
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestby" readonly></b-form-input>                                        
                  </b-input-group>
                  <b-input-group>
                      <b-input-group-prepend><label>Release to</label></b-input-group-prepend>
                      <b-form-input v-model="model.releaseto" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <span><a :href="viewrequestdetail(this.model.requestkey)" target="_blank" title="View Request RRD"><i class="fa fa-eye"></i> View Request RRD</a></span>
              </b-col>
          </b-row >
          <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Keterangan</label></b-input-group-prepend>
              <b-form-textarea
                id="textarea"
                v-model="model.uraianrequest"
                placeholder=""
                rows="3"
                max-rows="6"
                readonly
              ></b-form-textarea>
          </b-input-group>

          <div v-if="(this.model.send2wfrequest==1)">
            <label class="mt-3"><h6>Workflow process history</h6></label>
              <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="220px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="120px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p>
                  </td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="6" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="danger" class="ml-1" @click="showApprovalcancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
              <b-row class="justify-content-center mt-4" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send Approval Request</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalcancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal id="modal-prevent-closing"
      v-model="showExpiredConfirm" title="Expired Memo" :centered="true" @show="resetModal"
      @hidden="resetModal" @ok="handleExpiredOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <p class="mb-1">The selected a row of data will be expired?</p>
          <b-form-group
            label="Note"
            label-for="name-input"
            invalid-feedback="Note is required"
            :state="!$v.frmDtExpired.expired_note.$error"
          >
              <b-form-input
                id="name-input"
                v-model="frmDtExpired.expired_note"
                :state="!$v.frmDtExpired.expired_note.$error"
                required
              ></b-form-input>
            </b-form-group>
          </form>
      </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import releasedoc from "../../apis/releasedoc";
import pinjaman from '../../apis/pinjamankredit';
import task from "../../apis/task";
import project from "../../apis/project";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();
export default {
  components: { myNumber, Loading },
  mixins: [validationMixin],
  validations: {
    frmDtExpired:{expired_note:{required}}
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalcancelConfirm: false,
      showExpiredConfirm:false,
      model: {},
      frmDtExpired:{expired_note:""},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",
        status_approval: "",
        sourceproject: this.$store.state.user.compcode || "",
        contract_status:"",
        wo_status: "",
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        { value: "LIV", text: "Live"},
        { value: "ICP", text: "Incomplete Payment"},
        { value: "RRD", text: "Ready Release Document"},
      ],
      status_approval: [
        { value: "", text: "--- ALL ---" },
        { value: "Send Approval", text: "Send Approval" },
        { value: "Approved", text: "Approved (EXP)" },
        { value: "Rejected", text: "Rejected" },
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
      wostatus: dropdown.woStatus,
    };
  },
  computed: {
    invalidFrmDtExpired() {
      this.$v.frmDtExpired.$touch();
      return this.$v.frmDtExpired.$invalid;
    },
    tblFields() {
      const fields = [
         {
          key: "releaseno",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
         {
          key: "submitdate",
          label: "Tgl. Surat",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "duedate_memo",
          label: "Tgl. Jth Tempo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "paymentamt",
          label: "Ttl. Bayar (Harus)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "akumpaidamt",
          label: "Ttl. Bayar (Sudah)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "jaminanttl",
          label: "Jml. Jaminan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "jaminanamt",
          label: "Nilai Jaminan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createdbyfull",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "settlementdate",
          label: "Settlement Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "requestno",
          label: "Request No.",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        
        {
          key: "requestdate",
          label: "Request Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        
        {
          key: "created_by",
          label: "Request By.",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        
        {
          key: "status_memo_rrd",
          label: "Status Approval",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        }
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    const collSet = {
      tablename: "vwcollector",
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce((arr = [{ value: "", text: "--- ALL ---" }], item, index) => {
      arr.push({
        value: item.pjxkey,
        text: item.pjxname,
      });
      return arr;
    }, [{ value: "", text: "--- ALL ---" }]);

    this.tblData.pjxkey = this.tblData.pjxkey || (this.sourceproject.length>0?this.sourceproject[0].value:''); 
    if(this.$route.params&&this.$route.params.contract_status){
      this.tblData.contract_status = this.$route.params.contract_status;
      this.refresh();
    }
  },
  methods: {
  
    // async exportDtl() {
    //   if (this.model.pinjamankey) {
    //     try {
    //       await pinjaman.exportDtlxls(this.model.pinjamankey);
    //     } catch (error) {
    //       this.isBusy = false;
    //       if (error.message) {
    //         toastr.error(error.message, "ERROR MESSAGE", 10000);
    //       } else {
    //         toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
    //       }
    //     }
    //   } else {
    //     toastr.warn("Please select a row that want to export detail");
    //   }
    // },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        const list = await releasedoc.settled(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.collectability = "";
      this.tblData.sourceproject = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nomor = "";
      this.tblData.agreement = "";
      this.tblData.dod1 = 0;
      this.tblData.dod2 = 0;
      this.tblData.status = "";
      this.tblData.status_approval = "";
      this.tblData.wo_status = "";
      this.tblData.pjxkey = "";
      this.refresh();
    },
    async exportxls() {
      try {
        await pinjaman.exportxlsRRD(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async stopaccrue() {
      try {
        await pinjaman.stopaccrue(this.model);
        this.refresh();
        toastr.success(`Success,Stop Accrue`, "", 10000);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async startaccrue() {
      try {
        await pinjaman.startaccrue(this.model);
        this.refresh();
        toastr.success(`Success,Reverse Stop`, "", 10000);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async writeoff() {
      try {
        await pinjaman.writeoff(this.model);
        this.refresh();
        toastr.success(`Success,Write Off `, "", 10000);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },


    resetModal() {
      this.frmDtExpired.expired_note = ''
    },
    handleExpiredOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (this.invalidFrmDtExpired) {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
          return;
      }
      this.expireddata()
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    approvalConfirm: async function () {
        if (this.model.requestkey) {   
            this.model.rrd_dt = this.model.rrd_dt
                  ? moment(this.model.rrd_dt).format("DD MMM YYYY")
                  : "";
            this.model.requestdate = this.model.requestdate
                  ? moment(this.model.requestdate).format("DD MMM YYYY")
                  : "";
            this.model.alamatDebitur = `${this.model.alamatktp}, kecamatan: ${this.model.kecamatanktp}, kelurahan: ${this.model.kelurahanktp}, kota: ${this.model.kotaktp}`;
            this.model.value_of_asset = this.model.value_of_asset ? this.model.value_of_asset.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : "";
            if (this.model.send2wfrequest==1) {
              try {
                const data = await task.approvalhistory({key: this.model.requestkey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            formData.append('requestkey', this.model.requestkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await pinjaman.approvalpelepasandoc(formData);
            this.model.send2wf=1;
            toastr.success("Send Approval Request RRD successfully.");
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await pinjaman.approvalUndoRRD(this.model);
            this.model.send2wfrequest=0;
            this.showApprovalConfirm = false;
            toastr.success("Cancel Approval Request RRD successfully.");
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.pinjamankey) {
          this.isLoading=true;
          try {
              this.reportUrl= await task.approvalprint({key: this.model.pinjamankey});
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    viewagreementcard(pinjamankey){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey}}).route.path;
      return `#`+url;
    },

    requestrrd(){
      if (this.model.pinjamankey) {
          router.push({name:'loan.requestpelepasandokumensebagianfrm',
          params:{releaseKey:this.model.releaseKey, pinjamankey:this.model.pinjamankey}});
      } else {
          toastr.warn('Please select a row that want to be Requested!');
      }
    },
     approvalInfoConfirm: async function (record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      setTimeout(() => {
        this.approvalInfo();
      }, 500);
    },
    viewrequestdetail(){
      const url = router.resolve({name:'loan.requestrrdview',params:{requestkey:this.model.requestkey}}).route.path;
      return `#`+url;
    },
    close() {
      router.push("home");
    },
  },
};
</script>